const styles = (theme) => ({
  //   mainContent: {
  //     minHeight: "100vh",
  //     backgroundColor: "#F6F8FA",
  //     padding: "24px",
  //   },
  mainContent: {
    marginLeft: 180,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 80,
    },
  },
  formContainer: {
    maxWidth: "800px",
    // margin: "0 auto",
    marginTop: 40,
    padding: "24px",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
  },
  headerContainer: {
    marginBottom: "32px",
  },
  title: {
    fontSize: "1.75rem",
    fontWeight: 600,
    color: theme.palette.darkGrey.main,
    marginBottom: "8px",
  },
  subtitle: {
    color: "#697386",
    fontSize: "0.875rem",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  input: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
  multiSelect: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
  submitButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "1rem",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.darkGrey.main,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
  },
  // Prénom / Nom et Ville / Code postal : la prop `gap` de Box n'existe pas en v4
  row: {
    gap: 16,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  errorMessage: {
    color: "#DC3545",
    fontSize: "0.875rem",
    marginTop: "4px",
  },
  successMessage: {
    color: "#28A745",
    fontSize: "0.875rem",
    marginTop: "4px",
  },
  "@media (max-width: 600px)": {
    formContainer: {
      padding: "16px",
    },
    title: {
      fontSize: "1.5rem",
    },
  },
});

export default styles;
